// File: src/components/auth/TaskRedirect.tsx
// Purpose: Universal task redirect - routes to admin or staff page based on user role
// InstaDev - Task Redirect

import { Navigate, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import type { RootState } from '@/store'

export function TaskRedirect() {
  const { taskId } = useParams<{ taskId: string }>()
  const { isAuthenticated, userType } = useSelector((state: RootState) => state.auth)

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // Determine redirect path based on user type
  const isAdmin = userType?.toLowerCase() === 'admin'

  const targetPath = isAdmin
    ? `/dashboard/admin/sprints?task=${taskId}`
    : `/staff/sprints?task=${taskId}`

  return <Navigate to={targetPath} replace />
}
